import { render, staticRenderFns } from "./Todo.vue?vue&type=template&id=4a925e8a&"
import script from "./Todo.vue?vue&type=script&lang=js&"
export * from "./Todo.vue?vue&type=script&lang=js&"
import style0 from "./Todo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports